<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ForMedia.translations.json";
	import footerImg from "../assets/images/footerHp.png?webp";
	import mediaBanner from "../assets/images/media-banner.png?webp&w=1920&imagetools";
	import HeroBanner from "../components/HeroBanner.svelte";
	import ForMediaBannerText from "../components/ForMediaBannerText.svelte";
	import type { ForMediaProps } from "./ForMediaProps.js";
	import { DocumentCategory } from "../../../core/schema/DocumentCategory.js";
	import DocumentsOfCategory from "../components/DocumentsOfCategory.svelte";

	type $$Props = ForMediaProps;

	const { documents } = $$restProps as $$Props;

	const translate = getTranslate(translations);

	const categories = [
		DocumentCategory.MediaCenter,
		DocumentCategory.AnnualReports,
		DocumentCategory.PressReleases,
		DocumentCategory.BranoNewspaper,
	] as const;
	const categoryNameMap = {
		[DocumentCategory.AnnualReports]: "annualReports",
		[DocumentCategory.BranoNewspaper]: "branoNews",
		[DocumentCategory.MediaCenter]: "mediaCenter",
		[DocumentCategory.PressReleases]: "pressReleases",
	} satisfies Record<(typeof categories)[number], keyof typeof translations>;
</script>

<Layout footerImage={footerImg}>
	<HeroBanner
		title={translate("heading")}
		titleClass="sm:w-3/4"
		textColor="black"
		overlay="white-70"
		hideShowMore
		backgroundImage={mediaBanner}
	>
		<div class="flex flex-col gap-5 lg:grid lg:grid-cols-2">
			{#each categories as category}
				<ForMediaBannerText {category} title={translate(categoryNameMap[category])} />
			{/each}
		</div>
	</HeroBanner>

	<div class="md:container">
		{#each categories as category}
			{@const documentsOfCategory = documents.filter((document) => document.category === category)}
			{#if documentsOfCategory.length > 0}
				<DocumentsOfCategory {category} documents={documentsOfCategory} title={translate(categoryNameMap[category])} />
			{/if}
		{/each}
	</div>
</Layout>
